import { safeGet } from "@app/shared/utils/secure/safe-get";
import { createSelector } from "@ngrx/store";
import { selectGenderState } from "../reducers";
import * as fromGender from "../reducers/gender.reducer";

export const selectGenderListIsLoading = () =>
  createSelector(selectGenderState(), fromGender.selectIsLoading);

export const selectGenderTypeEntities = () =>
  createSelector(selectGenderState(), fromGender.selectGenderTypeEntities);

export const selectAllGenderTypes = () =>
  createSelector(selectGenderState(), fromGender.selectAllGenderTypes);

export const selectFilterGenderTypes = () =>
  createSelector(selectAllGenderTypes(), (allGenderTypes) => [
    ...allGenderTypes,
  ]);

export const selectGenderTypeById = (id: number) =>
  createSelector(selectGenderTypeEntities(), (genderTypeEntities) =>
    safeGet(genderTypeEntities, String(id)),
  );
